import React, { FC } from 'react';
import { Radio } from '@mui/material';
import { ReactComponent as Visa } from '../../../../../assets/images/paymentTypeMethods/VisaLogo.svg';
import { ReactComponent as VisaDark } from '../../../../../assets/images/paymentTypeMethods/VisaLogoDark.svg';
import { ReactComponent as MasterCard } from '../../../../../assets/images/paymentTypeMethods/MasterCardLogo.svg';
import { ReactComponent as UseNewCard } from '../../../../../assets/images/paymentTypeMethods/UseNewCard.svg';
import { ReactComponent as UseNewCardDark } from '../../../../../assets/images/paymentTypeMethods/UseNewCardDark.svg';
import { ReactComponent as GPay } from '../../../../../assets/images/paymentTypeMethods/GPayLogo.svg';
import { ReactComponent as GPayDark } from '../../../../../assets/images/paymentTypeMethods/GPayLogoDark.svg';
import { ReactComponent as ApplePay } from '../../../../../assets/images/paymentTypeMethods/ApplePayLogo.svg';
import { ReactComponent as ApplePayDark } from '../../../../../assets/images/paymentTypeMethods/ApplePayLogoDark.svg';
import { ReactComponent as DefaultCard } from '../../../../../assets/images/paymentTypeMethods/DefaultCard.svg';
import {
  UnknownCardSystem,
  CardSystem,
  PaymentDefaultItems,
  PaymentSystem,
  PaymentSystemItems,
} from '../../../../../models/Common';
import { BasicButton } from '../../../buttons/BasicButton/BasicButton';
import { IPaymentCard } from '../../../../../models/PaymentCard';
import { getCreditCardType } from '../../../../../utils';

interface PaymentTypeItemProps {
  theme: string;
  typeMethod: IPaymentCard | PaymentDefaultItems | PaymentSystemItems;
  cardId?: number;
  selectedCard: number | undefined;
  handleSelect: (cardId?: number) => void;
  newCardText?: string;
}

interface ItemContentProps {
  content: string;
  logo: JSX.Element;
  id?: number;
}

const defaultProps = {
  newCardText: '',
  cardId: undefined,
};

export const PaymentTypeItem: FC<PaymentTypeItemProps> = ({
  cardId,
  typeMethod,
  selectedCard,
  theme,
  handleSelect,
  newCardText,
}) => {
  const getIconPaymentTypeLogo = (
    type: IPaymentCard | PaymentDefaultItems | PaymentSystemItems,
    colorTheme: string,
  ): ItemContentProps => {
    switch (true) {
      case getCreditCardType((type as IPaymentCard).Card) === CardSystem.VISA: {
        return {
          logo: colorTheme === 'light' ? <Visa /> : <VisaDark />,
          content: (type as IPaymentCard).Card,
          id: (type as IPaymentCard).id,
        };
      }
      case getCreditCardType((type as IPaymentCard).Card) === CardSystem.MASTERCARD: {
        return {
          logo: <MasterCard />,
          content: (type as IPaymentCard).Card,
          id: (type as IPaymentCard).id,
        };
      }
      case type === PaymentSystem.GOOGLE_PAY: {
        return {
          logo: colorTheme === 'light' ? <GPay /> : <GPayDark />,
          content: PaymentSystem.GOOGLE_PAY,
        };
      }
      case type === PaymentSystem.APPLE_PAY: {
        return {
          logo: colorTheme === 'light' ? <ApplePay /> : <ApplePayDark />,
          content: PaymentSystem.APPLE_PAY,
        };
      }
      case type === UnknownCardSystem.NEW_CARD_DEFAULT: {
        return {
          logo: colorTheme === 'light' ? <UseNewCard /> : <UseNewCardDark />,
          content: newCardText || '',
        };
      }
      default: {
        return {
          logo: <DefaultCard />,
          content: (type as IPaymentCard).Card,
          id: (type as IPaymentCard).id,
        };
      }
    }
  };

  const content = getIconPaymentTypeLogo(typeMethod, theme);

  const select = () => {
    handleSelect(content.id);
  };

  return (
    <BasicButton
      handleClick={select}
      className={`payment__type__container__content__payment-method__list__item ${
        cardId === selectedCard ? 'selected-card' : ''
      }`}
    >
      <div className="item-name">
        <div className="item-name__logo">{content.logo}</div>
        <div className="item-name__content">
          <p>{content.content}</p>
        </div>
      </div>
      <div className="item-arrow">
        <Radio name="pCard" checked={cardId === selectedCard} className="input input__radio" />
      </div>
    </BasicButton>
  );
};

PaymentTypeItem.defaultProps = defaultProps;
